import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { ApplicationUser } from 'src/models/application-user';
import { map, tap } from 'rxjs/operators';
// {
//     providedIn: 'root'
// }
@Injectable()
export class FunctionService {


    provider:any;
  
    constructor(private http: HttpClient) {}
    chekclanguage(datalink  , currentLanguage  ) {
        if(JSON.parse(datalink) == null || JSON.parse(datalink) == "" || JSON.parse(datalink) == {}){
            // console.log(JSON.parse(datalink))
          return null ;
        }
        if( currentLanguage == 'en')
        {
          return   JSON.parse(datalink).en;
        }
        else  if( currentLanguage == 'ar')
        {
          return   JSON.parse(datalink).ar;
        }
        else  if(  currentLanguage == 'tr')
        {
          return    JSON.parse(datalink).tr;
        }
       }
   
  
}